import Vue from 'vue'
import crmService from '@/services/crm_service'
import { langByLocale } from '@/utils'

const state = {
  values: {},
  translations: []
}

const mutations = {
  'SET_VALUES' (state, { id, values }) {
    Vue.set(state.values, id, values)
  },
  'SET_TRANSLATIONS' (state, tr) {
    state.translations = tr
  }
}

const actions = {
  getPicklistValues ({ commit }, { id, locale }) {
    const lang = langByLocale(locale)
    crmService.getPicklistValues(id, (values) => {
      commit('SET_VALUES', { id: id, values: values })
      const valueIds = values.map(obj => obj.id)
      crmService.getPicklistTranslations(valueIds, lang, (tr) => {
        commit('SET_TRANSLATIONS', tr)
      })
    })
  }
}

const getters = {
  picklistValues: (state) => (id, locale) => {
    const values = state.values[id] || []
    return values.map(val => {
      const tr = state.translations.find(tr => {
        return tr.id === val.id && tr.attributes.lang === langByLocale(locale)
      })
      const label = tr ? tr.attributes.translation : ''
      const value = val.attributes.value
      return { label, value }
    })
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
